module.exports = __webpack_public_path__ + "files/sap-mob300certificate.4a83b88f.pdf";